import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DurationValue } from './models/duration-value';

const DurationPickerComponentProvider = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DurationPickerComponent),
  multi: true,
};

/**
 * The duration picker component
 */
@Component({
  selector: 'ideom-duration-picker',
  templateUrl: './duration-picker.component.html',
  styleUrls: ['./duration-picker.component.scss'],
  providers: [DurationPickerComponentProvider],
})
export class DurationPickerComponent implements ControlValueAccessor {
  /**
   * The flag indicating that control is disabled
   */
  @Input() disabled: boolean;

  /**
   * The input name
   */
  @Input() name: string;

  /**
   * The flag indicating to show days
   */
  @Input() days = true;

  /**
   * The flag indicating to show hours
   */
  @Input() hours = true;

  /**
   * The flag indicating to show minutes
   */
  @Input() minutes = true;

  /**
   * The flag indicating to show seconds
   */
  @Input() seconds = true;

  /**
   * The picker value
   */
  value = new DurationValue();

  /**
   * @ignore
   */
  onChange: (value: string | undefined) => void;

  /**
   * @ignore
   */
  onTouched: () => void;

  /**
   * @ignore
   */
  registerOnChange(fn: (value: string | undefined) => void): void {
    this.onChange = fn;
  }

  /**
   * @ignore
   */
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  /**
   * @ignore
   */
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  /**
   * @ignore
   */
  writeValue(value: string | undefined): void {
    this.value = new DurationValue(value);
  }

  /**
   * This method is used for triggering changes
   */
  triggerChange() {
    this.onTouched();
    this.onChange(this.value.toString());
  }
}
